// Libraries
import { action, computed } from "mobx";

// Core
import { FieldType } from "Core/Utils/Utils";
import { ViewModelBase } from "Core/ViewModels/ViewModelBase";

// Custom
import { isNullOrUndefined } from "Custom/Utils/Utils";
import { RoofSystemModel } from "Custom/Models/Domain/ProductSelector/SubModels/RoofSystem";

import { DelcoteProductsViewModel } from "./RoofSystemSubViewModels/DelcoteProductsViewModel";
import { SeamsilProductsViewModel } from "./RoofSystemSubViewModels/SeamsilProductsViewModel";
import { ProductsCommonViewModel } from "./RoofSystemSubViewModels/ProductsCommonViewModel";
import { DelglazeViewModel } from "./RoofSystemSubViewModels/DelglazeViewModel";

export class RoofSystemViewModel extends ViewModelBase<RoofSystemModel> {
    private delglazeViewModel: DelglazeViewModel;
    private delcoteProductsViewModel: DelcoteProductsViewModel;
    private seamsilProductsViewModel: SeamsilProductsViewModel;
    private productsCommonViewModel: ProductsCommonViewModel;

    constructor(model: RoofSystemModel) {
        super(model);

        this.delglazeViewModel = new DelglazeViewModel(model.DelglazeModel);
        this.delcoteProductsViewModel = new DelcoteProductsViewModel(model.DelcoteProducts);
        this.seamsilProductsViewModel = new SeamsilProductsViewModel(model.SeamsilProducts);
        this.productsCommonViewModel = new ProductsCommonViewModel(model);
    }

    // #region Subviewmodel Properties

    public get DelglazeViewModel(): DelglazeViewModel {
        return this.delglazeViewModel;
    }

    public get DelcoteProductsViewModel(): DelcoteProductsViewModel {
        return this.delcoteProductsViewModel;
    }

    public get SeamsilProductsViewModel(): SeamsilProductsViewModel {
        return this.seamsilProductsViewModel;
    }

    public get ProductsCommonViewModel(): ProductsCommonViewModel {
        return this.productsCommonViewModel;
    }

    // #endregion Subviewmodel Properties

    // #region Product Selection

    @computed
    public get products(): any[] {
        return this.model.products;
    }

    @computed
    public get productSelection(): any {
        return this.model.getProductSelection;
    }

    @action
    public setProductSelection = (value: string): void => {
        const item: any = this.model.products.find((item: any) => {
            return item.value.toString() === value;
        });

        this.model.setProductSelection(item);

        // Prviously, there was only two options,
        if (value === "id_seamsil") {
            this.delcoteProductsViewModel.setProductSelection(undefined);
        } else {
            this.delcoteProductsViewModel.setProductSelection(value);
        }
    };

    // #endregion Product Selection

    // #region Seamsil

    @computed
    public get canDisplaySeamsil(): boolean {
        return !isNullOrUndefined(this.model.getProductSelection) && this.model.getProductSelection.value === "id_seamsil";
    }

    // #endregion Seamsil

    // #region Delcote

    @computed
    public get canDisplayDelcote(): boolean {
        const item: any = this.model.getProductSelection;
        return (
            !isNullOrUndefined(item) &&
            (item.value === "id_delcotesubstratemetal10" || item.value === "id_delcotesubstratemetal25" || item.value === "id_delcotesubstratefibrecement")
        );
    }

    // #endregion Delcote

    // #region Viewmodel Boilerplate

    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    public isFieldValid(fieldName: keyof FieldType<RoofSystemModel>): boolean {
        return true;
    }

    // #endregion Viewmodel Boilerplate
}
